import { call, put, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import { mapActivityData } from 'utils/activities'
import {
  addArray as addNotificationsArray,
  setLoadStatus,
  setLastLoadedId
} from '../redux/notifications'

export default function * fetchNotifications (action) {
  yield put(setLoadStatus({
    isLoading: true,
    isLoaded: false
  }))

  const state = yield select()

  const lastLoadedId = state.kanbo.notifications.lastLoadedId
  const unreadOnly = state.kanbo.notifications.unreadOnly

  let args = {
  }

  if (unreadOnly) {
    args.wasRead = false
  }

  if (lastLoadedId) {
    args.olderThanId = lastLoadedId
  }

  try {
    const Notifications = yield call(apiGetData, 'MyNotifications', args)

    let notifications = []
    let newLastLoadedId = null

    Notifications.forEach(Notification => {
      const notification = {
        ...mapActivityData(Notification),
        wasRead: Notification.WasRead
      }

      notifications.push(notification)

      if (lastLoadedId === null || lastLoadedId > notification.id) {
        newLastLoadedId = notification.id
      }
    })

    const batchedActions = [
      addNotificationsArray(notifications),
      setLoadStatus({
        isLoading: false,
        isLoaded: Notifications.length < 20
      })
    ]

    if (newLastLoadedId !== null) {
      batchedActions.push(setLastLoadedId({ lastLoadedId: newLastLoadedId }))
    }

    yield put(batchedActions)
  } catch (error) {
    yield put(setLoadStatus({
      isLoading: false,
      isLoaded: false
    }))

    throw error
  }
}
